import { render } from "./DocVerFirmarGuardar.vue?vue&type=template&id=64830c0c&scoped=true"
import script from "./DocVerFirmarGuardar.vue?vue&type=script&lang=js"
export * from "./DocVerFirmarGuardar.vue?vue&type=script&lang=js"

import "./DocVerFirmarGuardar.vue?vue&type=style&index=0&id=64830c0c&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64830c0c"]])

export default __exports__